import React from 'react';

import { MetadataAndHistoryTool } from 'js/components/Assessment/Editors/common/Tools/MetadataAndHistoryTool';
import { AnswerSetTool } from 'js/components/Assessment/Editors/common/Tools/AnswerSetTool';

/**
 * The live editor's sidebar. It omits the survey editor's `CategoryTool`
 * because live assessments do not group question sets into categories, but keeps
 * the answer-set library so authors can borrow or publish likert scales.
 */
export function Tools({
  docTemplateId,
  assessment,
  revisions,
  revisionsQueryIsLoading,
}) {
  return (
    <>
      <MetadataAndHistoryTool
        docTemplateId={docTemplateId}
        assessment={assessment}
        revisionsQueryIsLoading={revisionsQueryIsLoading}
        revisions={revisions}
      />
      <AnswerSetTool assessment={assessment} />
    </>
  );
}

export default Tools;
